export default {
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},

	getStartDd_: ({ searchParams }) => searchParams.startDd,
	getEndDd_: ({ searchParams }) => searchParams.endDd,

	searchParams_: ({ RtnPartMstPopup }) => RtnPartMstPopup
};
